import React from "react";

export default function WhiteCirclePlus(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
			<path
				data-name="add (1)"
				d="M9 0a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm3.938 9.75H9.75v3.188a.75.75 0 0 1-1.5 0V9.75H5.063a.75.75 0 0 1 0-1.5H8.25V5.063a.75.75 0 0 1 1.5 0V8.25h3.188a.75.75 0 0 1 0 1.5Zm0 0"
				fill="#fff"
			/>
		</svg>
	);
}
